
<div class="App">
    <SiteHeader />
    <HeroSection />
    <TSEKonformitatSection />
    <Features />
    <PricingSection />
    <Partner />

    <Contact />
    <FAQ />

    <SiteFooter />

    <CookieConsent />
</div>
